import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

export type WaveformStoreContext = {
  waveformData?: number[];
};

const defaultContext: WaveformStoreContext = {
  waveformData: undefined,
};

export const waveformStore = createStoreWithProducer(produce, defaultContext, {
  setWaveformData: (context, event: { data: number[] }) => {
    context.waveformData = event.data;
  },
  clearWaveformData: (context) => {
    context.waveformData = undefined;
  },
});
